import React from 'react';
import withTranslation from '../../../hoc/withTranslation';
import { ListItem } from 'material-ui';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import IconMenu from 'material-ui/IconMenu';
import style from '../../../styles/styles';
import MenuItem from 'material-ui/MenuItem';
import AdminService, { ADMIN } from '../../../services/admin';
import { connect } from 'react-redux';
import { dispatchInfo } from '../../../store/infos/actions';

class AccessTokenList extends React.Component {
    static propTypes = {
        accessToken: PropTypes.object.isRequired,
        app: PropTypes.object,
        handleRemoveAccessToken: PropTypes.func,
        dispatchInfo: PropTypes.func,
    };

    handleRemoveAccessToken = () => {
        this.props.handleRemoveAccessToken(this.props.accessToken);
    };

    copyToClipboard = () => {
        navigator.clipboard.writeText(this.props.accessToken.token);
        this.props.dispatchInfo(this.props.t('generic.copy_clipboard'));
    };

    rightIconButton = () => {
        if (!this.props.user || !this.props.app) {
            return;
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400} />
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
                targetOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
            >
                {AdminService.isAuthorized(ADMIN, this.props.user)
                    && (
                        <MenuItem onClick={this.copyToClipboard}>
                            {this.props.t('generic.copy')}
                        </MenuItem>
                    )
                }
                {AdminService.isAuthorized(ADMIN, this.props.user)
                    && this.props.handleRemoveAccessToken
                    && (
                        <MenuItem onClick={this.handleRemoveAccessToken}>
                            {this.props.t('generic.remove')}
                        </MenuItem>
                    )
                }
            </IconMenu>
        );
    };

    render() {
        const { accessToken } = this.props;

        return (
            <ListItem
                primaryText={accessToken.name}
                secondaryText={accessToken.token}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default connect(null, { dispatchInfo })(withTranslation(AccessTokenList));



// WEBPACK FOOTER //
// src/components/common/AccessTokenSetting/AccessTokenList.js